import CircleInfo from '@gef-ui/material-icons/CircleInfo';
import Box from '@mui/material/Box';
import { useFormControl } from '@mui/material/FormControl';
import Tooltip from '@mui/material/Tooltip';
import PropTypes from 'prop-types';
import isObject from "ramda-extension/es/isObject";
import React, { useState } from 'react';
import { useDefaultComponentValue } from '../utils';
const COMPONENT_NAME = 'FieldTooltip';
const resolvePlacement = (placement, size)=>{
    const negativeSmallOffset = size === 'small' ? 3 : 0;
    const baseSize = `-${11 - negativeSmallOffset}px`;
    if (isObject(placement)) {
        return placement;
    } else if (placement === 'field-left') {
        return {
            top: baseSize,
            left: baseSize
        };
    } else if (placement === 'field-right') {
        return {
            top: baseSize,
            right: baseSize
        };
    } else if (placement === 'chip-left') {
        return {
            top: `-${21 - negativeSmallOffset}px`,
            left: baseSize
        };
    } else if (placement === 'checkbox-left') {
        return {};
    }
};
const FieldTooltip = (inProps)=>{
    const [open, setOpen] = useState(false);
    const formControlContext = useFormControl();
    const props = useDefaultComponentValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { message, placement = 'field-right', Icon = CircleInfo, color = 'action', OpenIcon = CircleInfo, openColor = 'action', size = formControlContext?.size } = props;
    return message ? /*#__PURE__*/ React.createElement(Tooltip, {
        title: message,
        placement: "top",
        open: open,
        onClose: ()=>setOpen(false),
        onOpen: ()=>setOpen(true)
    }, /*#__PURE__*/ React.createElement(Box, {
        component: "span",
        sx: [
            {
                position: 'absolute',
                cursor: 'default',
                ...resolvePlacement(placement, size),
                zIndex: 2,
                '&::before': {
                    position: 'absolute',
                    content: '""',
                    borderRadius: '50%',
                    backgroundColor: 'background.paper',
                    zIndex: -1
                }
            },
            size === 'small' ? {
                '&::before': {
                    top: '3px'
                }
            } : {
                '&::before': {
                    top: '4px'
                }
            },
            size === 'small' ? {
                '&::before': {
                    left: '3px'
                }
            } : {
                '&::before': {
                    left: '4px'
                }
            },
            size === 'small' ? {
                '&::before': {
                    width: '14px'
                }
            } : {
                '&::before': {
                    width: '16px'
                }
            },
            size === 'small' ? {
                '&::before': {
                    height: '14px'
                }
            } : {
                '&::before': {
                    height: '16px'
                }
            }
        ]
    }, open ? /*#__PURE__*/ React.createElement(OpenIcon, {
        color: openColor,
        sx: {
            display: 'block'
        },
        fontSize: size
    }) : /*#__PURE__*/ React.createElement(Icon, {
        color: color,
        sx: {
            display: 'block'
        },
        fontSize: size
    }))) : null;
};
FieldTooltip.propTypes = {
    Icon: PropTypes.elementType,
    OpenIcon: PropTypes.elementType,
    color: PropTypes.string,
    left: PropTypes.string,
    message: PropTypes.string,
    openColor: PropTypes.string,
    placement: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    right: PropTypes.string,
    size: PropTypes.string,
    top: PropTypes.string
};
export default FieldTooltip;
